<template>
    <component
        :is="element"
        class="element"
        :class="[
            color && `color_${color}`,
            font && `font_${font}`,
            animation && `animation_${animation}`,
        ]">
        <Icon v-if="icon" :type="icon" :rotate="iconRotate" :size="iconSize" class="icon" />
        <slot />
    </component>
</template>

<script lang="ts">
    import { PropType, defineComponent } from 'vue';
    import { Element, Animation, Font, Size, Color } from './Element.interfaces';
    import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'Element',
        components: { Icon },
        props: {
            element: {
                type: String as PropType<Element>,
                default: 'span',
            },
            animation: {
                type: String as PropType<Animation>,
                default: 'none',
            },
            color: {
                type: String as PropType<Color>,
            },
            iconSize: {
                type: String as PropType<Size>,
                default: 'none',
            },
            font: {
                type: String as PropType<Font>,
                default: 'font-body-m',
            },
            icon: {
                type: String as PropType<IconType>,
            },
            iconRotate: Number,
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Element.scss';
</style>
